import React, { useState } from 'react';
import { Shield, Eye, EyeOff, X, Loader2 } from 'lucide-react';
import { api } from '../lib/api';

export default function AdminLogin({ setScreen, setAdminAuthed }) {
  const [email, setEmail] = useState('');
  const [pwd, setPwd] = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!email.trim() || !pwd) return;
    setErr('');
    setBusy(true);
    try {
      await api.post('/api/admin/session', { email: email.trim(), password: pwd });
      setAdminAuthed(true);
      setScreen('admin');
    } catch (e) {
      setErr(e.message || 'Connexion impossible.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="page narrow center-col">
      <div className="gate-card">
        <div className="gate-ico admin"><Shield size={22} /></div>
        <h2 className="gate-h">Espace administrateur</h2>
        <p className="gate-p">Réservé au compte administrateur configuré sur ce site.</p>
        <input
          className="gate-input left"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Adresse e-mail"
          autoFocus
        />
        <div className="pwd-row">
          <input
            className="gate-input left"
            type={show ? 'text' : 'password'}
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            placeholder="Mot de passe administrateur"
          />
          <button className="pwd-eye" onClick={() => setShow(!show)}>{show ? <EyeOff size={16} /> : <Eye size={16} />}</button>
        </div>
        {err && <div className="gate-err"><X size={14} /> {err}</div>}
        <button className="btn-primary wide" onClick={submit} disabled={!email.trim() || !pwd || busy}>
          {busy ? <Loader2 size={16} className="spin" /> : null} Se connecter
        </button>
        <button className="link-btn subtle center" onClick={() => setScreen('landing')}>← Retour</button>
      </div>
    </div>
  );
}
